import { blockUI } from 'angular';

import { CodeTypeModel }            from '../../app-lite/core/models/code-type';
import { CompanyIntegrationsModel } from '../../app-lite/companies/models/company.integrations';
import { StripeAccountLinkModel }   from '../../app-lite/stripe/models/stripe.account-link';
import { StripeAccountModel }       from '../../app-lite/stripe/models/stripe.account';
import { StripeService }            from '../../app-lite/stripe/stripe.service';

interface StripeSettingsScope extends ng.IScope {
  account   : StripeAccountModel;
  accounts  : Array<CodeTypeModel>;
  block     : blockUI.BlockUIService;
  connect   : () => void;
  disable   : () => void;
  enabling  : boolean;
  save      : () => void;
  settings  : CompanyIntegrationsModel;
  stripeApi : StripeService;
}

export function StripeSettingsCtrl (
  $q        : ng.IQService,
  $rootScope: any,
  $state    : ng.ui.IStateService,
  $scope    : StripeSettingsScope,
  $translate: ng.translate.ITranslateService,
  $window   : ng.IWindowService,
  blockUI   : blockUI.BlockUIService,
  confirm   : any,
  messages  : any,
  settings  : CompanyIntegrationsModel,
  stripeApi : StripeService
) {
  $scope.account  = null;
  $scope.accounts = [];
  $scope.block    = blockUI.instances.get('stripeSettingsBlock');
  $scope.enabling = false;
  $scope.settings = settings;

  $scope.stripeApi = stripeApi;

  $scope.connect = function () : void {
    $scope.stripeApi.connect()
    .then(( account : StripeAccountLinkModel ) => {
      $window.location.assign(account.url);
    });
  };

  $scope.disable = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'WorkshopPay' }))
    .then(() => $scope.stripeApi.disable())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'WorkshopPay' }), 'success');

      /**
       * For australian customers who don't have stripe enabled,
       * they cannot activate stripe and must use workshopPay instead.
       * So once they deactivate, redirect them away from stripe
       * settings since it is no longer available to them.
       * Reference: WOR-2560
       */
      if ($rootScope.Company.country('australia')) {
        $state.go('app');
      }
      else {
        $state.reload();
      }
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  $scope.save = function () {
    $scope.stripeApi.saveSettings($scope.settings)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  if ($scope.stripeApi.isLinked()) {
    $scope.enabling = true;

    $scope.stripeApi.get()
    .then(( account : StripeAccountModel ) => {
      $scope.account = account;

      return ( $scope.stripeApi.isActive($scope.account) && !$rootScope.Company.hasIntegration('stripe') ) ?
        $scope.stripeApi.enable()
        .then(() => {
          $state.reload();

          return true;
        }) :
        $q.when(true);
    })
    .finally(() => {
      $scope.enabling = false;
    });
  }

  if ($scope.stripeApi.hasAccounting()) {
    $scope.block.start();

    $scope.stripeApi.getAccounts()
    .then(( accounts : Array<CodeTypeModel> ) => {
      $scope.accounts = accounts;
    })
    .finally(() => {
      $scope.block.stop();
    });
  }
};
